import { render } from "./slider.vue?vue&type=template&id=2166d3cc&scoped=true&ts=true"
import script from "./slider.vue?vue&type=script&lang=ts"
export * from "./slider.vue?vue&type=script&lang=ts"

import "./slider.vue?vue&type=style&index=0&id=2166d3cc&scoped=true&lang=less"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2166d3cc"]])

export default __exports__